<template>
  <div>
    <div class="navigation">
      <div class="navigation__items">
        <button @click="navigate(0)">ZBC</button>
        <button @click="navigate(1)">Werkwijze</button>
        <button @click="navigate(2)">Bewind</button>
        <button @click="navigate(3)">Leden</button>
      </div>
    </div>
    <div class="background">
      <div class="company">
        <h1>Zeeuws Bewindvoerders Collectief</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";

export default {
  name: "Header",
  methods: {
    navigate(value) {
      EventBus.$emit("navigate", value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/style.scss";

.background {
  height: 150px;
  width: 100%;
  position: relative;
  background: url("../assets/vectorpaint.svg") no-repeat;
  background-size: 100% 150px;
  mask-image: linear-gradient(to bottom, transparent 1%, black 80%);
  z-index: 1000;

  @media only screen and (min-width: 768px) {
    height: 275px;
    background-size: 100% 275px;
  }
}

.navigation {
  position: relative;
  height: 40px;
}

.navigation__items {
  width: 100%;
  position: absolute;
  top: 0rem;
  right: 0;
  display: flex;
  justify-content: center;

  button {
    color: $themeColor;
    transition: color 0.2s ease;

    &:hover {
      color: $secondaryColor;
    }
  }

  @media only screen and (min-width: 768px) {
    margin-right: 1rem;
    justify-content: flex-end;
  }
}

.company {
  width: 90%;
  position: absolute;
  bottom: 1rem;
  right: 50%;
  transform: translateX(50%);
  color: white;

  @media only screen and (min-width: 768px) {
    bottom: 4rem;
  }
}
</style>
